export class FlowTestObject {
    events: Array<FlowTestEvent> = [];
    instance: FlowTestInstance = null;
}

export class FlowTestEvent {
    jsonAdditionalFields: string;
    eventTs: number = new Date().getTime();
    flowInstanceId: string;
    flowTypeCode: string;
    lineageJsonData: string;
    lineageProcessingId: string;
    message: string;
    rawEventUuid: string;
    status: string;
    stepTypeCode: string;
}

export class FlowTestProcessedStep {
    rawKey: string;
    status: string;
    stepTypeCode: string;
    timestamp: number;
}


export class FlowTestInstance {
    compliant: boolean = true;
    endTs: number = 0;
    flowTypeCode: string;
    id: string;
    lastStep: string;
    lastUpdate: number = 0;
    leadTimes: Record<string, string>;
    matchedClosureId: string;
    nextDeadline: number = 0;
    processedSteps: Record<string, FlowTestProcessedStep>;
    startTs: number = 0;
    status: string;
    timeout: number = 0;
}


